import styled from 'styled-components';
import slide1 from 'assets/images/desktop/slide1.jpg';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  background: url(${slide1}) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 6%;
  position: relative;

  @media screen and (min-width: 2140px) {
    background-position-y: top;
  }
`;

export const Headline = styled.h1`
  font-size: 40px;
  line-height: 40px;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 24px;
`;

export const Text = styled.article`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #fff;
  max-width: 296px;
  margin-bottom: 24px;
`;

export const Caption = styled.div`
  display: block;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #fff;
  padding-top: 24px;
  width: 100%;
  max-width: 320px;
  border-top: 1px solid #ffffff50;

  span {
    font-family: ${fonts.BentonSansBold};
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  bottom: 4%;
  right: 4%;
  text-align: right;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.2px;
  color: #d4d4d4;
  max-width: 152px;
  margin-bottom: 24px;
`;
